<template>
  <!-- A Payments tab section: caret + title + count (or a summary), open when it
       has something in it and collapsed when it's empty (until toggled).
       Flat: a plain sub-heading inside another section, always open. -->
  <section>
    <div class="wp-section-head">
      <h3 v-if="flat" class="wp-subsection-title">{{ title }}</h3>
      <button v-else type="button" class="wp-section-toggle" :aria-expanded="isOpen ? 'true' : 'false'" @click="open = !isOpen">
        <i class="fa-solid fa-caret-right wp-section-toggle__icon" :class="{ 'is-open': isOpen }" aria-hidden="true"></i>
        <h2 class="wp-section-title">{{ title }}</h2>
        <span v-if="count !== null" class="wp-section-count">({{ count }})</span>
        <span v-if="summary" class="wp-section-summary">{{ summary }}</span>
        <span v-if="badge" class="charge-badge" :class="`charge-badge--${badge.tone}`">{{ badge.text }}</span>
      </button>
      <div v-if="(isOpen || actionsWhenClosed) && $slots.actions" class="wp-section-actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <div v-show="isOpen" class="wp-section-body">
      <slot></slot>
    </div>
  </section>
</template>
<script>
export default {
  name: 'payments-section',
  props: {
    title: { type: String, required: true },
    // null while loading (shown open, so the spinner is visible)
    count: { type: Number, default: null },
    // Shown instead of a count, e.g. "1 enrollment · 2 passes left"
    summary: { type: String, default: null },
    badge: { type: Object, default: null },
    // Overrides "open when count > 0" (until someone toggles it)
    defaultOpen: { type: Boolean, default: null },
    flat: { type: Boolean, default: false },
    // Keep the actions slot visible while collapsed (e.g. a link to add the first item)
    actionsWhenClosed: { type: Boolean, default: false },
  },
  data() {
    return {
      // null until someone toggles it
      open: null,
    };
  },
  computed: {
    isOpen() {
      if (this.flat) {
        return true;
      }
      if (this.open !== null) {
        return this.open;
      }
      if (this.defaultOpen !== null) {
        return this.defaultOpen;
      }
      return this.count === null || this.count > 0;
    },
  },
};
</script>
